export default __webpack_public_path__ + "static/media/sb-title-en.4af36613.webp";